(function($) {
$(function(){


  /*****
    Append a grid-view toggle, but only locally
  *****/
  $('body.is-local').append('<div id="toggle-grid" style="position: fixed; bottom: 10px; left: 10px; cursor: pointer; box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); border-radius: 10px; background: white; color: black; font-weight: bold; font-size: 18px; padding: 5px 8px; z-index: 1000;">Grid</div>');
  $(document).on('click', '.is-local #toggle-grid', function(e){
    e.preventDefault();
    $('body').toggleClass('grid-view');
  });

  /*****
    Set some global variables
  *****/
  var template_url = $('#template_url').val();


  /*****
    iOS Viewport check
  *****/
  var isVHCheckNeeded = vhCheck();
  var hasVHCKeckValue = document.documentElement.style.getPropertyValue('--vh-offset');
  if (isVHCheckNeeded && hasVHCKeckValue) {
    $('body').addClass('use-ios-offset');
  }


  /*****
    Nav toggle
  *****/
  $('.site-menu-toggle').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('html').attr('data-nav-state', $('html').attr('data-nav-state') == 'closed' ? 'open' : 'closed');
  });


  /*****
    Responsive videos
  *****/
  $(".nice-type").fitVids();
  $(".home-video-item").fitVids();


  /*****
    Hover service item (to fade images)
  *****/
  if ($('.service-item').length) {
    $('.service-item a').hover(function(){
      $(this).parent('.service-item').addClass('hovered');
    }, function(){
      $(this).parent('.service-item').removeClass('hovered');
    });
  }


  /*****
    Re-scan salvattore columns
  *****/
  if ($('[data-columns]').length) {
    $(window).resize($.throttle(200, function(){
      salvattore.rescanMediaQueries();
    }));
  }



  /*****
    Flickity
  *****/
  if ($('.home-header-slides').length) {
    var home_carousel = $('.home-header-slides').flickity({
      cellSelector: '.home-header-slide',
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: 5000,
      wrapAround: true,
      imagesLoaded: false,
      fade: true
    });

    $('.home-header-slides').waitForImages(function() {
      $('.home-header-slide-image').addClass('show');
    });
  }


});
})(jQuery);
